import { render } from "./bottomCard.vue?vue&type=template&id=79510b4a"
import script from "./bottomCard.vue?vue&type=script&lang=js"
export * from "./bottomCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__